import { bopApi } from '@/lib/api/client';
import type { ReportType } from '@/services/api/reports';

const GENERATE_PATH = 'v1/compliance/dac8-audit/generate';

export const DAC8_REPORT_TYPE: ReportType = 'dac8-audit';

export interface Dac8AuditRunRequest {
  /** Reporting calendar year; the API defaults to the current UTC year when omitted */
  year?: number;
}

export interface Dac8AuditRunAccepted {
  year: number;
  requestedBy: string;
  /** ISO-8601 */
  requestedAt: string;
}

/**
 * Starts a DAC8 audit run. The response only acknowledges the request: the worker runs for
 * minutes and announces the file over the websocket as `reportReady` / `reportFailed` with
 * reportType 'dac8-audit', so pages must wait through useAsyncReport.
 */
export const requestDac8AuditReport = (body: Dac8AuditRunRequest) => bopApi.post(GENERATE_PATH, { json: body }).json<Dac8AuditRunAccepted>();
